import React from 'react';
import {Helmet} from 'react-helmet-async';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Box from 'shared/ui/Box/Box';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import {getPortMonitorName, PortMonitorBackgroundKind} from 'features/port/lib/portMonitorHelper';
import usePortMonitorDetails from 'features/port/model/usePortMonitorDetails';

import PortMonitorHeader from './PortMonitorHeader/PortMonitorHeader';
import PortMonitorSummary from './PortMonitorSummary/PortMonitorSummary';
import PortMonitorChecks from './PortMonitorChecks/PortMonitorChecks';
import PortMonitorIncidents from './PortMonitorIncidents/PortMonitorIncidents';

import styles from './PortMonitorDetails.module.scss';

const BACKGROUND_CLASSES: Record<PortMonitorBackgroundKind, string> = {
    en: styles.enContainer,
    paused: styles.pausedBackground,
    problem: styles.problemBackground,
    ok: styles.okBackground,
};

const PortMonitorDetails: React.FC = () => {
    const {portMonitor, isLoading, isMobile, backgroundKind} = usePortMonitorDetails();

    if (isLoading || !portMonitor || !backgroundKind) {
        return <LoaderCentered active/>;
    }

    return (
        <>
            {
                isMobile &&
                <div className={styles.containerHeader}>
                    <PortMonitorHeader portMonitor={portMonitor}/>
                </div>
            }

            <Box className={cn(styles.container, BACKGROUND_CLASSES[backgroundKind])}>
                <Helmet>
                    <title>{`${getPortMonitorName(portMonitor)} | ${t`Overseer`}`}</title>
                </Helmet>

                {
                    !isMobile &&
                    <>
                        <PortMonitorHeader portMonitor={portMonitor}/>
                        <span className={styles.line}/>
                    </>
                }
                <PortMonitorSummary portMonitor={portMonitor}/>
            </Box>

            <PortMonitorChecks portMonitor={portMonitor}/>

            <PortMonitorIncidents portMonitorId={portMonitor.uuid} monitor={portMonitor}/>
        </>
    );
};

export default PortMonitorDetails;
